import React, { Component } from 'react'
import { Card, CardBody, Row, Col, Label, Spinner } from 'reactstrap'
import moment from 'moment'
import { graphClient } from '../../store/sagas/auth'
import { notifyError } from '../../utils/notify'

export default class News extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      news: [],
    }
  }

  async componentDidMount() {
    try {
      this.setState({ loading: true })

      const siteId = 'ecossissolucoes.sharepoint.com,916518f4-6a95-4033-9f7b-828bc9242dfe,77f5b67e-2563-4879-9689-76396da0d67a'

      const news = await graphClient
        .api(`sites/${siteId}/pages?filter=startsWith(pageLayout, 'Article')&$orderby=lastModifiedDateTime desc&$top=4`)
        .version('beta')
        .get()

      console.tron.log('news', news.value)

      this.setState({ loading: false, news: news.value })
    } catch (err) {
      notifyError(err)
      this.setState({ loading: false, news: [] })
    }
  }

  render() {
    const { loading, news } = this.state

    return (
      <Card>
        <CardBody>
          <Row className="d-flex justify-content-between">
            <Col>
              <h4 className="card-title mb-4">Notícias</h4>
            </Col>
            <Col className="d-flex justify-content-end">
              <a
                target="_blank"
                rel="noreferrer"
                href="https://ecossissolucoes.sharepoint.com/sites/PortaldeColaboradores/_layouts/15/news.aspx?newsSource=1&instanceId=3c3acc5f-432c-4b7b-a6b3-0426a6dad5cf&webPartId=8c88f208-6c77-4bdb-86a0-0c47b4316588&serverRelativeUrl=%2Fsites%2FPortaldeColaboradores&pagesListId=32edf452-49ef-4414-b7b1-9d03a9366a87"
              >
                Ver tudo
              </a>
            </Col>
          </Row>
          {loading && (
            <Row>
              <Col className="d-flex align-items-center justify-content-center py-2">
                <Spinner size="sm" />
              </Col>
            </Row>
          )}
          {!loading && news && news.length > 0 && (
            news.map((article, index) => (
              <Row key={article.id} className="news-item">
                <Col>
                  <Label>
                    {moment(article.lastModifiedDateTime).format('DD/MM/YY')}
                  </Label>
                  <br />
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href={`https://ecossissolucoes.sharepoint.com/sites/PortaldeColaboradores/${article.webUrl}`}
                    /* style={{ fontSize: 16 }} */
                  >
                    {article.title}
                  </a>
                  {index !== news.length - 1 && (
                    <hr style={{ marginBottom: 24, marginTop: 22 }} />
                  )}
                </Col>
              </Row>
            ))
          )}
        </CardBody>
      </Card>
    )
  }
}
